<template>
  <ul class="footer flex jc-sa w100pc fixed bott0 bg-fff aic footer">
    <li class="item">
      <router-link
        to="/index"
        class="flex2 aic f20 yellow"
        active-class="active"
      >
        <span class="home icon"></span>
        <p class="mt-5 f12 text">主页</p>
      </router-link>
    </li>
    <li class="item">
      <router-link
        to="/class"
        class="flex2 aic f20 yellow"
        active-class="active"
      >
        <span class="class icon"></span>
        <p class="mt-5 f12 text">分类</p>
      </router-link>
    </li>
    <li class="item">
      <router-link to="/my" class="flex2 aic f20 text" active-class="active">
        <span class="my icon"></span>
        <p class="mt-5 text f12">我的</p>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1.8rem;
  z-index: 20;
  border-top: 1px solid #ebebeb;

  .text {
    color: #797d82;
  }

  .active .text {
    color: #42686e;
  }

  .icon {
    display: inline-block;
    width: 0.9rem;
    height: 0.9rem;
  }

  .home {
    background: url("./../assets/img/my/home.png") no-repeat center center;
    background-size: 90%, 100%;
  }

  .active .home {
    background: url("./../assets/img/my/home-act.png") no-repeat center center;
    background-size: 90%, 100%;
  }

  .active .class {
    background: url("./../assets/img/my/class-act.png") no-repeat center center;
    background-size: 90%, 100%;
  }

  .class {
    background: url("./../assets/img/my/class.png") no-repeat center center;
    background-size: 90%, 100%;
  }

  .active .my {
    background: url("./../assets/img/my/my-act.png") no-repeat center center;
    background-size: 90%, 100%;
  }

  .my {
    background: url("./../assets/img/my/my.png") no-repeat center center;
    background-size: 90%, 100%;
  }
}
</style>
